<template>
  <div style="padding:15px;height: calc(100% - 35px); position:relative;">
    <v-layout
      row
      xs12
      sm12
      md12
      v-if="transaction.payed == 0"
      style="height: 90%; border-top: 1px solid #ddd;border-bottom: 1px solid #ddd"
    >
      <v-flex xs4 sm4 md4 style="padding: 10px; border-right: 1px solid #ddd">
        <v-card style="padding:15px; margin-bottom:10px;">
          <v-card-title style="color: #777777;">{{transaction.affair}}</v-card-title>
          <v-card-text style="color: #777777;">{{ 'params.import' | i18n}}: {{transaction.import}}{{ coin }}</v-card-text>
          <v-card-text style="color: #777777;">{{ 'params.date' | i18n}}: {{transaction.date}}</v-card-text>
        </v-card>
        <div id="summary" class="hide-scrollbars">
          <div id="summaryHeader">
            <p style="color: #777777;">{{ 'Summary.label' | i18n}}</p>
            <span v-if="Object.keys(payments.summary).length == 0">*{{ 'Summary.not_values' | i18n}}</span>
          </div>
          <div v-for="(summary, index) in payments.summary" class="summaryOption">
            <div>
              <span>{{summary.name}}</span>
              <p>{{summary.amount}}{{ coin }}</p>
            </div>
            <span v-on:click="removePayment(index)" style="cursor:pointer">
              <img height="15px" src="/img/delete_alert.svg" />
            </span>
          </div>
          <div class="summaryInfo" v-on:click="summary = !summary">
            <div>
              <span>{{ 'Total' | i18n}}</span>
              <span
                :style="[payments.total == transaction.import ? {color: '#3da903'} : {color: '#d80000'} ]"
              >{{ payments.total }}/{{transaction.import}}{{ coin }}</span>
            </div>
          </div>
        </div>
      </v-flex>
      <v-flex xs8 sm8 md8 style="padding: 10px;height:height: calc(100% - 113px); overflow-y: scroll;">
        <v-layout row>
          <v-flex xs6 sm6 d-flex style="margin-right:10px;">
            <v-text-field hide-details prepend-icon="search" single-line v-model="search"></v-text-field>
          </v-flex>
          <v-flex xs6 sm6 d-flex>
            <v-select
              :items="Object.keys(budgets)"
              :label="'finances.conciliate.club_selector' | i18n"
              v-model="clubSelected"
              @change="searcher(clubSelected)"
            ></v-select>
          </v-flex>
        </v-layout>
        <div v-if="Object.keys(budgets).length > 0">
          <div v-for="(club, key) in budgets" :id="key" class="club" style="margin-bottom:10px;">
            <div class="dropdown" style="cursor:pointer;" @click="setVisible(key)">
              <span>{{key}}</span>
              <img src="/img/down_dark.svg" height="10px" style="padding-right:5px;" />
            </div>
            <div
              class="dropdown-content"
              :style="[budgets[key][0].active ? {display: 'block'} : {display: 'none'} ]"
            >
              <ul class="budgets">
                <li v-for="budget in club">
                  <p
                    v-on:click="setSelected(budget, key)"
                    :id="budget.id"
                    v-if="selected.id != budget.id"
                  >
                    {{budget.team_name}}
                    <span
                      v-if="payments.summary[budget.id] != undefined"
                      style="color:#3da903"
                    >(+{{payments.summary[budget.id].amount}}{{ coin }})</span>
                    <span
                      style="float:right"
                    >{{ 'payed' | i18n}}: {{budget.payed}} - {{budget.total}}{{ coin }}</span>
                  </p>
                  <div v-if="selected.id == budget.id" class="amountSelector">
                    <input type="range" class="input-range" name id v-model="amountSelected" />
                    <div class="selectorAmount">
                      <input type="number" v-model="amount" v-bind:max="total" min="0" />
                    </div>
                    <button v-on:click="addPayment()">{{ 'finances.conciliate.assign' | i18n}}</button>
                    <span
                      v-on:click="selected.id = ''; amountSelected = 0; amount = 0"
                      class="closeBtn"
                    ></span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-else id="no_budgets">{{ 'finances.conciliate.no_budget' | i18n}}</div>
      </v-flex>
    </v-layout>
    <div v-if="transaction.payed == 1" class="actions">
      <v-card style="padding:15px; margin-bottom:10px;">
        <v-card-title style="color: #777777;">{{transaction.affair}}</v-card-title>
        <v-card-text style="color: #777777;">{{ 'params.import' | i18n}}: {{transaction.import}}{{ coin }}</v-card-text>
        <v-card-text style="color: #777777;">{{ 'params.date' | i18n}}: {{transaction.date}}</v-card-text>
      </v-card>
      <div>
        <span style="color: #777777;">{{ 'Summary.label' | i18n}}</span>
        <div v-for="(summary, index) in paymentsTransaction" class="summaryOption">
          <div>
            <span>{{summary.budget.team_name}}</span>
            <p>{{summary.import}}{{ coin }}</p>
          </div>
        </div>
      </div>

      <div class="item remove" @click="unsettle">{{ 'finances.conciliate.undo' | i18n}}</div>
    </div>
    <div v-else id="btn_save">
      <div
        class="save"
        :class="{disabled: payments.total != transaction.import}"
        v-on="payments.total == transaction.import ? { click: () => save() } : {click: ($event) => $event.preventDefault() }"
      >{{ 'finances.conciliate.save' | i18n}}</div>
      <div class="delete" @click="deleteTransaction()">{{ 'finances.conciliate.delete' | i18n}}</div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import store from "@/store";

export default {
  props: { params: Array, actions: Array },
  components: {},
  data() {
    return {
      search: "",
      selected: {
        club: "",
        id: ""
      },
      amountSelected: 0,
      amount: 0,
      payments: {
        summary: {},
        total: 0
      },
      summary: false,
      selected_club: false,
      budgets: {},
      clubSelected: ""
    };
  },
  computed: {
    coin(){
        let event = this.$store.getters[ 'events/getCurrentEvent' ]()
        return event.type_id == 15 ? '$' : '€'
    },
    transaction() {
      var transaction = {
        ...store.getters["finances/get_transaction_by_id"](
          this.params["transaction_id"]
        )
      };
      return transaction;
    },
    total() {
      return this.transaction.import - this.payments.total;
    },
    paymentsTransaction() {
      var path = `finances/getPayments`;
      var payments = {
        ...store.getters[path](this.id)
      };
      return payments;
    }
  },
  methods: {
    save() {
      this.$emit("save", { type: "save", action: "save" });
    },
    setSelected(budget, key) {
      if (this.payments.summary[budget.id] == undefined) {
        this.selected.id = budget.id;
        this.selected.club = key;
      }
      this.amountSelected = 0;
      this.amount = 0;
    },
    addPayment() {
      var total = 0;
      this.amount = parseFloat(this.amount);
      if (
        this.amount == 0 ||
        this.payments.total + this.amount > this.transaction.import
      )
        return false;
      var self = this;
      var aboveImport = false;
      for (const key in this.budgets) {
        self.budgets[key].forEach(function(budget) {
          if (
            budget.id == self.selected.id &&
            self.amount > budget.total - budget.payed
          )
            aboveImport = true;
        });
      }
      if (aboveImport) return false;
      if (this.payments.summary[this.selected.id] != undefined) {
        total =
          this.payments.total -
          this.payments.summary[this.selected.id].amount +
          this.amount;
        if (total <= this.transaction.import) {
          this.payments.summary[this.selected.id].amount = this.amount;
          this.payments.total = total;
        }
      } else {
        total = this.payments.total + this.amount;
        if (total <= this.transaction.import) {
          let budget = this.getSelectedBudget();
          let payload = {
            budget_id: this.selected.id,
            name: budget.team_name,
            amount: this.amount
          };
          this.payments.summary[this.selected.id] = payload;
          this.payments.total = total;
        }
      }
      this.params["payments"] = this.payments;
      this.setSelected({ id: "" }, "");
    },
    removePayment(id) {
      this.payments.total -= this.payments.summary[id].amount;
      delete this.payments.summary[id];
    },
    deleteTransaction() {
      var self = this;
    //   self.$emit("close");
      self.$popup.confirm(
        {
          message: i18n.t("finances.conciliate.delete_confirm"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel")
        },
        function() {
          store
            .dispatch("finances/deleteTransaction", self.transaction.id)
            .then(response => {
                self.$emit("save", { type: "remove", action: "remove" });
                self.$emit("close");
            });
        },
        function() {}
      );
    },
    unsettle() {
      var self = this;
    //   self.$emit("close");
      self.$popup.confirm(
        {
          message: i18n.t("finances.conciliate.unconciliate"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel")
        },
        function() {
          store
            .dispatch("finances/unConciliate", self.transaction.id)
            .then(response => {
                self.$emit("save", { type: "remove", action: "remove" });
                self.$emit("close");
            });
        },
        function(err) {}
      );
    },
    setVisible(key) {
      var cBudgets = { ...this.budgets };
      cBudgets[key][0].active = !cBudgets[key][0].active;
      this.budgets = cBudgets;
    },
    firstData() {
      var cbudgets = { ...store.getters["finances/getUnpayed"]() };
      for (const budget in cbudgets) {
        cbudgets[budget][0].active = false;
      }

      this.budgets = cbudgets;
    },
    getSelectedBudget() {
      var budget = false;
      if (this.budgets[this.selected.club]) {
        this.budgets[this.selected.club].forEach(cbudget => {
          if (cbudget.id == this.selected.id) {
            budget = { ...cbudget };
          }
        });
      }
      return budget;
    },
    searcher(value) {
      var a, i, txtValue;
      var input = value;
      var filter = input.toUpperCase();
      var divs = document.getElementsByClassName("club");
      for (i = 0; i < divs.length; i++) {
        var div = divs[i].getElementsByTagName("div");
        //buscamos primero sobre el primer div para encontrar si coincide con el
        var p = div[0].getElementsByTagName("span")[0];
        txtValue = p.textContent || p.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          divs[i].style.display = "";
        } else {
          divs[i].style.display = "none";
        }
      }
    }
  },

  watch: {
    search: {
      handler: function(value) {
        this.searcher(value);
      },
      deep: true
    },
    amountSelected: {
      handler(percent) {
        var budget = this.getSelectedBudget();
        let total = budget.total - budget.payed;
        let budgetPercent = Math.round(total * (percent / 100) * 100) / 100;
        total = this.transaction.import - this.payments.total;
        let transactionPercent =
          Math.round(total * (percent / 100) * 100) / 100;
        this.amount =
          budgetPercent > transactionPercent
            ? transactionPercent
            : budgetPercent;
      },
      deep: true
    }
  },
  created() {
    var self = this;
    if (this.transaction.payed == 0) {
      store.dispatch("finances/loadListUnpayed").then(function() {
        self.firstData();
      });

      this.$emit("expand", true);
    } else {
      store
        .dispatch(
          "finances/paymentsByTransaction",
          this.params["transaction_id"]
        )
        .then(function() {});
    }
  }
};
</script>

<style lang="scss" scoped>
.msg {
  width: 100%;
  float: left;
  padding: 30px 20px;
  overflow: hidden;

  &.expanded {
    width: 50%;
  }
}

.hide-scrollbars,
.hide-scrollbar {
  overflow: -moz-scrollbars-none !important;
  -ms-overflow-style: none !important;
}

.hide-scrollbars::-webkit-scrollbar,
.hide-scrollbar::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}
.hide-scrollbars::-webkit-scrollbar-thumb,
.hide-scrollbar::-webkit-scrollbar-thumb {
  background: transparent;
}

#summary {
  height: calc(100% - 113px);
  min-height: 280px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  flex-wrap: no-wrap;
  justify-content: flex-start;
}
#summaryHeader {
  p {
    color: #444;
    text-align: center;
    font-weight: bold;
  }
  span {
    color: #777;
    text-align: center;
    width: 100%;
    font-weight: 500;
    display: block;
    margin-top: 10px;
    min-height: 100px;
  }
}
.budgets {
  list-style-type: none;
  padding: 0;
  margin: 0;

  li {
    padding: 5px;
    text-decoration: none;
    font-size: 18px;
    display: block;
    border-bottom: 1px solid #eee;
  }

  p {
    color: #777777;
    cursor: pointer;
  }
  span {
    color: #777777;
  }
}

.summaryOption {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  margin-bottom: 5px;

  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 20px);
    span {
      display: inline-block;
      max-width: calc(100% - 75px);
      @include text-ellipsis();
    }
    p {
      width: 75px;
      text-align: right;
    }
  }
  > span {
    width: 20px;
  }
}
.amountSelector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    width: 85px;
  }
  input {
    width: 60%;
  }
  button {
    height: 25px;
    width: 70px;
    text-align: center;
    border-radius: 3px;
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    cursor: pointer;
    background-color: #6f83c1;

    &:hover {
      background-color: #253554;
    }
  }
}
.closeBtn {
  cursor: pointer;
  width: 25px;
  height: 25px;
  align-items: center;
  border: 1px solid;
  display: flex;
  justify-content: center;
  border-radius: 2px;
  color: #777777;
  &:after {
    content: "\2A2F";
  }
}
.summaryInfo {
  margin: auto;
  margin-bottom: 0;
  width: 100%;
  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    background-color: #eee;
    padding: 5px 10px;
    span {
      font-weight: bold;
      text-transform: uppercase;
    }
  }
}

.actions {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 10px 10%;

  .item {
    line-height: 35px;
    font-size: 18px;
    font-weight: lighter;
    padding: 6px 15px 6px 15px;
    width: 100%;
    margin: 5px 0;
    border-radius: 3px;
    color: #fff;
    text-align: left;
    padding-left: 50px;

    background-color: $complem-color;
    background-repeat: no-repeat;
    background-position: left 20px center;
    background-size: 15px;
    cursor: pointer;

    &.profile {
      background-image: url(/img/goto_b.svg);
    }
    &.edit {
      background-image: url(/img/edit.svg);
    }
    &.save {
      background-color: #8bc34a;
      background-image: url(/img/download.svg);
    }
    &.remove {
      margin: auto;
      margin-bottom: 0;
      background-image: url(/img/remove.svg);
    }
  }
}

#btn_save {
  width: 100%;
  display: flex;
  div {
    width: 30%;
    height: 40px;
    color: white;
    padding: 5px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    cursor: pointer;
    margin: 10px;
    &.save {
      background-color: #3da903;
    }
    &.delete {
      background-color: #d80000;
    }
  }
}
#search {
  width: 50%;
}

.dropdown {
  height: 25px;
  background-color: #eee;
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
    color: #222;
    padding-left: 5px;
  }
}

.selectorAmount {
  display: flex;
  input {
    width: 75px !important;
    text-align: right;
    border-bottom: 2px solid #eee;
  }
  &:after {
    content: "€";
  }
}
.club_budgets {
  margin-bottom: 10px;
  div {
    padding: 2px 0px;
  }
}
body {
  color: #777777;
}

input[type="range"].input-range {
  $thumb-size: 16px;
  $thumb-color: #eee;
  $track-color: #eee;
  $bg-color: #ffffff;

  -webkit-appearance: none;
  width: 60%;
  margin: 6.5px 0;

  &:focus {
    outline: none;
  }
  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: $track-color;
    border-radius: 3px;
    border: none;
  }
  &::-webkit-slider-thumb {
    box-shadow: none;
    border: 2px solid $bg-color;
    height: $thumb-size;
    width: $thumb-size;
    border-radius: $thumb-size;
    background: $thumb-color;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -6.5px;
  }
  &:focus::-webkit-slider-runnable-track {
    background: #c7c7c7;
  }
  &::-moz-range-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: $track-color;
    border-radius: 3px;
    border: none;
  }
  &::-moz-range-thumb {
    box-shadow: none;
    border: 2px solid $bg-color;
    height: $thumb-size;
    width: $thumb-size;
    border-radius: $thumb-size;
    background: $thumb-color;
    cursor: pointer;
  }
  &::-ms-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  &::-ms-fill-lower {
    background: #6b6b6b;
    border: none;
    border-radius: 6px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-fill-upper {
    background: $track-color;
    border: none;
    border-radius: 6px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-thumb {
    box-shadow: none;
    border: 2px solid $bg-color;
    height: $thumb-size;
    width: $thumb-size;
    border-radius: $thumb-size;
    background: $thumb-color;
    cursor: pointer;
    height: 3px;
  }
  &:focus::-ms-fill-lower {
    background: $track-color;
  }
  &:focus::-ms-fill-upper {
    background: #c7c7c7;
  }
}

.disabled {
  background-color: #eee !important;
  color: #aaa !important;
  cursor: default !important;
}

>>> .v-label {
  margin-top: 0 !important;
}

#no_budgets {
  text-align: center;
  align-items: center;
  background-color: #eee;
  padding: 10px;
  font-weight: 600;
}
</style>